import { render, staticRenderFns } from "./ShoppingCartItemExt.vue?vue&type=template&id=15ba7956&scoped=true&"
import script from "./ShoppingCartItemExt.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartItemExt.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartItemExt.vue?vue&type=style&index=0&id=15ba7956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ba7956",
  null
  
)

export default component.exports